export const listPlaybookInsights = (playbook = {}) => [
  ...(playbook.positive || []),
  ...(playbook.negative || []),
];

export const getInsightAddedAt = (insight) =>
  typeof insight?.addedAt === "number" ? insight.addedAt : 0;

export const getPlaybookLastSeenAt = (playbook) =>
  typeof playbook?.lastSeenAt === "number" && playbook.lastSeenAt > 0
    ? playbook.lastSeenAt
    : 0;

export const isInsightNewSince = (insight, lastViewedAt) => {
  if (!lastViewedAt) {
    return true;
  }
  return getInsightAddedAt(insight) > lastViewedAt;
};

export const countNewInsights = (playbook, lastViewedAt) =>
  listPlaybookInsights(playbook).filter((insight) =>
    isInsightNewSince(insight, lastViewedAt)
  ).length;
